module.exports = __webpack_public_path__ + "img/ICONOS SOSRecurso 1-2@2x.0ecd13e6.png";